import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSupplyCases, SupplyCase } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );

  return <GenericListPage<SupplyCase> useData={useSupplyCases} config={config} />;
};

export default List;
